import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { PRIMARY } from '../constants';

// ── Styles ────────────────────────────────────────────────────────────────────
export const inputStyle = {
  width: '100%',
  border: '1px solid #e4e9f0',
  borderRadius: 6,
  padding: '6px 10px',
  fontSize: '12px',
  outline: 'none',
  fontFamily: 'inherit',
  background: '#f8f9fb',
  boxSizing: 'border-box',
};

export const selectStyle = { ...inputStyle, cursor: 'pointer' };

// ── InspSectionTitle ──────────────────────────────────────────────────────────
export function InspSectionTitle({ label, color = 'text.secondary' }) {
  const borderColor =
    typeof color === 'string' && color !== 'text.secondary'
      ? alpha(color, 0.2)
      : '#e8edf2';
  return (
    <Typography
      sx={{
        fontWeight: 700, fontSize: '0.68rem', textTransform: 'uppercase',
        letterSpacing: '0.08em', mb: 1.25, mt: 2, pb: 0.5,
        color, borderBottom: `2px solid ${borderColor}`,
        '&:first-of-type': { mt: 0 },
      }}
    >
      {label}
    </Typography>
  );
}

// ── InspRow ───────────────────────────────────────────────────────────────────
export function InspRow({ label, children }) {
  return (
    <Box sx={{ mb: 1.5 }}>
      <Typography
        sx={{
          fontWeight: 700, fontSize: '0.68rem', color: 'text.secondary',
          textTransform: 'uppercase', letterSpacing: '0.08em', mb: 0.6,
        }}
      >
        {label}
      </Typography>
      {children}
    </Box>
  );
}

// ── InspInput ─────────────────────────────────────────────────────────────────
export function InspInput({ value, onChange, placeholder, type = 'text' }) {
  const [local, setLocal] = useState(value ?? '');
  useEffect(() => setLocal(value ?? ''), [value]);
  return (
    <input
      type={type}
      value={local}
      onChange={e => setLocal(e.target.value)}
      onBlur={() => { if (local !== (value ?? '')) onChange(local); }}
      onKeyDown={e => { if (e.key === 'Enter') e.target.blur(); }}
      placeholder={placeholder}
      style={inputStyle}
    />
  );
}

// ── Toggle ────────────────────────────────────────────────────────────────────
export function Toggle({ value, onChange }) {
  return (
    <Box
      onClick={() => onChange(!value)}
      sx={{
        width: 36, height: 20, borderRadius: 10,
        background: value ? PRIMARY : '#d4dbe6',
        cursor: 'pointer', position: 'relative',
        transition: 'background 0.2s', flexShrink: 0,
      }}
    >
      <Box
        sx={{
          position: 'absolute', top: 2,
          left: value ? 18 : 2,
          width: 16, height: 16, borderRadius: '50%',
          background: '#fff', transition: 'left 0.2s',
          boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
        }}
      />
    </Box>
  );
}

// ── ToggleRow ─────────────────────────────────────────────────────────────────
export function ToggleRow({ label, value, onChange }) {
  return (
    <Box
      sx={{
        display: 'flex', alignItems: 'center',
        justifyContent: 'space-between', mb: 1.5,
      }}
    >
      <Typography sx={{ fontSize: '0.78rem', color: '#3c4555', fontWeight: 500 }}>
        {label}
      </Typography>
      <Toggle value={!!value} onChange={onChange} />
    </Box>
  );
}